import { createContext } from 'react';
const RowContext = createContext({});
export default RowContext;
